import React from "react";
import { useTranslation } from "react-i18next";

const NoResults = () => {
  const { t } = useTranslation();

  return (
    <div className="text-center py-12">
      <div className="text-gray-400 text-6xl mb-4">{t("forms.grid.no_results")}</div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{t("forms.grid.no_results_title")}</h3>
      <p className="text-gray-600 mb-4">
        {t("forms.grid.no_results_desc")}
      </p>
      <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors">
        {t("forms.grid.clear_filters")}
      </button>
    </div>
  );
};

export default NoResults;